import classNames from "classnames";
import { CSSProperties } from "react";
import { useRecoilValue } from "recoil";

import { useLockBodyScrollModified } from "@/hooks/useLockBodyScrollModified";
import { useModalAppearing } from "@/hooks/useModalAppearing";

import { ModalPortal } from "../modals/ModalPortal";
import styles from "./ChatLinkMenu.module.scss";
import { chatLinkMenuCoord } from "./chatLinkMenuCoord";
import { ChatMenuItem } from "./ChatMenuItem";
import { MENU_HEIGHT } from "./useOpenChatChooseMenu";

interface ChatLinkMenuProps {
  isOpen: boolean;
  close(): void;
  productLink?: string;
  customStyles?: CSSProperties;
}

const ChatLinkMenu = ({
  isOpen,
  close,
  productLink = "",
  customStyles,
}: ChatLinkMenuProps) => {
  const coords = useRecoilValue(chatLinkMenuCoord);
  const { isVisible, mounting, hiding } = useModalAppearing({
    isOpen,
    timeout: 300,
  });

  useLockBodyScrollModified(isOpen);

  if (!isVisible) return null;

  const whatsUpShareLink = productLink
    ? `https://wa.me/79050221220?text=${productLink}`
    : "https://wa.me/79050221220";

  const instagramShareLink = "https://ig.me/m/look.online";

  return (
    <ModalPortal>
      <div
        className={classNames(styles.background, {
          [styles.show]: mounting,
          [styles.hide]: hiding,
        })}
      >
        <div className={styles.closeArea} onClick={close} />
        <div
          className={classNames(styles.container, {
            [styles.custom]: customStyles,
          })}
        >
          <div className={styles.closeArea} onClick={close} />
          <div
            className={classNames(styles.menuContainer, {
              [styles.showMenu]: mounting,
              [styles.hideMenu]: hiding,
            })}
            style={
              customStyles || {
                top:
                  coords.verticalOrientation === "bottom"
                    ? coords?.topCoord || 0 + MENU_HEIGHT
                    : coords?.topCoord || 0 - MENU_HEIGHT,
                left: coords.leftCoord,
                transformOrigin:
                  coords.verticalOrientation === "top"
                    ? "left bottom"
                    : "left top",
              }
            }
          >
            <ChatMenuItem
              text="WhatsApp"
              iconSrc="/static/img/icons-v6/whatsapp.svg"
              href={whatsUpShareLink}
            />
            <ChatMenuItem
              text="Telegram"
              iconSrc="/static/img/icons-v6/telegram.svg"
              href="https://t.me/lookonlinebot"
            />
            <ChatMenuItem
              text="Instagram"
              iconSrc="/static/img/icons-v6/instagram.svg"
              href={instagramShareLink}
            />
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default ChatLinkMenu;
